export default {
  getIsLogin: state => {
    return state.isURSLogin
  },
  getUserAddress: state => {
    return state.userAddress
  },
  getUserName: state => {
    return state.username
  },
  getOrderId: state => {
    return state.orderId
  },

  goodsInfo(state) {
    return state.data ? state.data.goodsInfo : {}
  },

  fissionData(state) {
    return state.fissionData ? state.fissionData : {}
  },
  ifNeedLogin(state) {
    return state.ifNeedLogin
  },
  ifNeedGoExperience(state) {
    return state.ifNeedGoExperience
  },
  conversionData(state) {
    return state.activityData ? state.activityData.conversionData : {}
  },
  ifNeedConversionLogin(state) {
    return state.ifNeedConversionLogin
  },
  ifConversionHasLogin(state) {
    return state.ifConversionHasLogin
  },
  getOrderAddress(state) {
    return state.orderAddress ? state.orderAddress : null
  }
}
